import React, { useContext } from 'react';
import { Accordion, Card } from 'react-bootstrap';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import AcceptedOrderLines from '../accepted/AcceptedOrderLines';
import SubstitutionOrderLines from './substitutions/SubstitutionOrderLines';
import OrderContext from '../OrderContext';
import { IconWrapper } from '../../../common/IconWrapper';

export default function IssuesTab({ orderLinesLoading }) {
    const { basket, orderHeader } = useContext(OrderContext);

    return (
        <>
            {basket.capped.length > 0 && (
                <Accordion defaultActiveKey="0">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            <span>
                                Capped{' '}
                                {orderHeader.orderStatus === 'OPEN' && (
                                    <span className={'issues-badge'}>{basket.capped.length}</span>
                                )}
                            </span>
                            {orderHeader.orderStatus === 'OPEN' && (
                                <span className={'panel-comment'}>
                                    These products are currently restricted in quantity. The quantity you
                                    requested exceeded this.
                                </span>
                            )}
                            <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <AcceptedOrderLines
                                    orderLines={basket.capped}
                                    loading={orderLinesLoading}
                                    showDeleteIcons={false}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
            {basket.presell.length > 0 && (
                <Accordion defaultActiveKey="0">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            <span>
                                Presells{' '}
                                {orderHeader.orderStatus === 'OPEN' && (
                                    <span className={'issues-badge'}>{basket.presell.length}</span>
                                )}
                            </span>
                            {orderHeader.orderStatus === 'OPEN' && (
                                <span className={'panel-comment'}>
                                    These products were ordered as a presell and have been added to this order
                                    for delivery.
                                </span>
                            )}
                            <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <AcceptedOrderLines
                                    orderLines={basket.presell}
                                    loading={orderLinesLoading}
                                    showDeleteIcons={false}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
            {basket.alternatives.length > 0 && (
                <Accordion defaultActiveKey="1">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="1">
                            <span>
                                Alternatives{' '}
                                {orderHeader.orderStatus === 'OPEN' && (
                                    <span className={'issues-badge'}>{basket.alternatives.length}</span>
                                )}
                            </span>
                            {orderHeader.orderStatus === 'OPEN' && (
                                <span className={'panel-comment'}>
                                    We have found the following alternative products. Add them to your order
                                    below to avoid having gaps on your shelves.
                                </span>
                            )}
                            <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <SubstitutionOrderLines
                                    orderLines={basket.alternatives}
                                    loading={orderLinesLoading}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
            {basket.substitutes.length > 0 && (
                <Accordion defaultActiveKey="2">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="2">
                            <span>
                                Substitutions{' '}
                                {orderHeader.orderStatus === 'OPEN' && (
                                    <span className={'issues-badge'}>{basket.substitutes.length}</span>
                                )}
                            </span>
                            {orderHeader.orderStatus === 'OPEN' && (
                                <span className={'panel-comment'}>
                                    We have found and added the following replacements to your order. Change
                                    the quantity below if you’d like more or fewer cases of these products.
                                </span>
                            )}
                            <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                                <SubstitutionOrderLines
                                    orderLines={basket.substitutes}
                                    loading={orderLinesLoading}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
            {basket.rejected.length > 0 && (
                <Accordion defaultActiveKey="3">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="3">
                            <span>
                                Rejections{' '}
                                {orderHeader.orderStatus === 'OPEN' && (
                                    <span className={'issues-badge'}>{basket.rejected.length}</span>
                                )}
                            </span>
                            {orderHeader.orderStatus === 'OPEN' && (
                                <span className={'panel-comment'}>
                                    These products are not currently live in our range and we did not find any
                                    suitable alternatives. Search the product catalogue to order other
                                    products instead.
                                </span>
                            )}
                            <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="3">
                            <Card.Body>
                                <AcceptedOrderLines
                                    orderLines={basket.rejected}
                                    loading={orderLinesLoading}
                                    disableEditing={true}
                                    showDeleteIcons={false}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
            {basket.contentLines.length > 0 && (
                <Accordion defaultActiveKey="4">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="4">
                            <span>
                                Added Lines{' '}
                                {orderHeader.orderStatus === 'OPEN' && (
                                    <span className={'issues-badge'}>{basket.contentLines.length}</span>
                                )}
                            </span>
                            {orderHeader.orderStatus === 'OPEN' && (
                                <span className={'panel-comment'}>
                                    Products you’ve ordered from ActivHUB, Connect Online, email or mobile.
                                </span>
                            )}
                            <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="4">
                            <Card.Body>
                                <AcceptedOrderLines
                                    orderLines={basket.contentLines}
                                    loading={orderLinesLoading}
                                    disableEditing={true}
                                    showDeleteIcons={false}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
        </>
    );
}
